import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectDataByKey } from 'src/storage/general.selectors';
import { Observable, forkJoin, concatMap, of } from 'rxjs';
import { map, take, toArray } from 'rxjs/operators';
import { DataLayerService } from '../dataLeyer/data-leyer.service';
import { UtmHandlerService } from '../utm-handler.service';

export interface GetBodyOptions {
    keys: string[];
    screenPercentage: string;
    leadId?: string;
    leadRequirement?: string;
    leadStatus?: string;
    getTenantPolicies?: boolean;
    getScore?: boolean;
    asesorCode?: string;
    bitacoraId?: string;
    getLeadDuplicated?: boolean;
    set_utm_campaign?: string;
    set_utm_content?: string;
    set_utm_medium?: string;
    set_utm_source?: string;
}
 

@Injectable({
    providedIn: 'root'
})
// esta clase se encarga de la obtención de datos del arbol del buscador y de la creacion de los bodies para el orquestador
export class GeneralDataService {
    utmHandlerService = inject(UtmHandlerService);

    
    constructor(private store: Store, private dataLayerService: DataLayerService) { }

    llenadodatosgenerales(): Observable<any> {
        const datosGenerales = {
            Cliente: {
            cedulaCliente: 0,
            celularCliente: 0,
            nombreCliente: "",
            tipoIdentificacion: ""
            },
            InfoArrendamiento: {
            tipoPropiedad: "",
            ubicacion: "",
            valorAdministracion: 0,
            valorArriendo: 0,
            fechaContrato: "",
            duracionContrato: "",
            ServiciosPublicos: false,
            PaquetesAsistencia: false,
            Department: "",
            DepartmentCode: "",
            CityProperty: "",
            UseProperty: "",
            Code: "",
            CityCode: ""
            },
            Propietario: {
            primerNombre: "",
            segundoNombre: "",
            primerApellido: "",
            segundoApellido: "",
            paisNacimiento: "",
            tipoIdentificacion: "",
            numeroIdentificacion: "",
            fechaExpedicion: "",
            correo: ""
            },
            PlanSeleccionado: {
            plan: "",
            valorPlan: 0
            },
            Inmueble: {
            ciudad: "",
            direccion: "",
            maticula: ""
            },
            Inquilino: {
            primerNombre: "",
            segundoNombre: "",
            primerApellido: "",
            segundoApellido: "",
            numCelular: "",
            correo: "",
            paisNacimento: "",
            fechaNacimento: "",
            tipoidentificacion: "",
            documentoIdentidad: "",
            fechaExpedicion: "",
            ciudad: "",
            direccion: ""
            },
            ResponseRiesgoConsultable: [
            {
                esRiesgo: false,
                tipoValidacion: "",
                mensajeValidacion: "",
                idRegistroValidacion: ""
            }
            ]
        };
    
        return this.getData(['PolicyHolder', 'Tenant', 'Property','ProductCode']).pipe(
            map(data => {
                if (data.PolicyHolder) {
                    datosGenerales.Cliente.celularCliente = Number(data.PolicyHolder.MobilePhone);
                    datosGenerales.Cliente.nombreCliente = data.PolicyHolder.LastName;
                    datosGenerales.Cliente.tipoIdentificacion = 'C';
                }
                if (data.Tenant) {
                    datosGenerales.Cliente.cedulaCliente = Number(data.Tenant.DocumentNumber);
                }
                if (data.Property) {
                    datosGenerales.InfoArrendamiento.tipoPropiedad = data.Property.UseProperty;
                    datosGenerales.InfoArrendamiento.ubicacion = data.Property.Department;
                    datosGenerales.InfoArrendamiento.valorAdministracion = Number(data.Property.AdministrationValue);
                    datosGenerales.InfoArrendamiento.valorArriendo = Number(data.Property.RentalFee);
                    datosGenerales.InfoArrendamiento.fechaContrato = data.Property.ContractStartDate;
                    datosGenerales.InfoArrendamiento.duracionContrato = data.Property.TemporaryContracted;
                    datosGenerales.InfoArrendamiento.Department = data.Property.Department;
                    datosGenerales.InfoArrendamiento.DepartmentCode = data.Property.DepartmentCode;
                    datosGenerales.InfoArrendamiento.CityProperty = data.Property.CityProperty;
                    datosGenerales.InfoArrendamiento.Code = data.Property.Code;
                    datosGenerales.InfoArrendamiento.CityCode = data.Property.CityCode;
                    datosGenerales.InfoArrendamiento.UseProperty = data.Property.UseProperty;
                    datosGenerales.Inmueble.ciudad = data.Property.CityProperty + ' - ' + data.Property.Department;
                    
                }
                if (data.ProductCode) {
                    datosGenerales.PlanSeleccionado.plan = data.ProductCode;
                    
                }
    
                return datosGenerales; // Return the updated object
            })
        );
    }
        
    

    getData(keys: string[]): Observable<any> {
        const observables = keys.map(key => this.store.select(selectDataByKey(key)).pipe(
            take(1),
            map(data => {
                return { [key]: data };
            })
        ));

        return of(...observables).pipe(
            concatMap(obs => obs),
            toArray(),
            map(results => {
                const result = results.reduce((acc, curr) => ({ ...acc, ...curr }), {});
                return result;
            })
        );
    }

    getbody(options: GetBodyOptions): Observable<any> {
        const { keys, screenPercentage, leadId, getTenantPolicies , leadRequirement , leadStatus , getScore , asesorCode,bitacoraId , getLeadDuplicated, set_utm_campaign, set_utm_content, set_utm_medium, set_utm_source } = options;

        const sessionId = this.dataLayerService.getLocalStorage().toString();

        const utmCampaign = this.utmHandlerService.getUtmParams()['utm_campaign'] || '';
        const utmContent = this.utmHandlerService.getUtmParams()['utm_content'] || '';
        const utmMedium = this.utmHandlerService.getUtmParams()['utm_medium'] || '';
        const utmSource = this.utmHandlerService.getUtmParams()['utm_source'] || '';
        const gClid = this.utmHandlerService.getUtmParams()['gclid'] || '';

        // Evitar subscribes separados: pedir todas las claves necesarias en una sola llamada
        const extraKeys = ['leadId', 'asesorCode', 'bitacoraId'];
        const allKeys = Array.from(new Set([...(keys || []), ...extraKeys]));

        return this.getData(allKeys).pipe(
            map(allData => {
                console.log('allData', allData)
                // Construir productsConfigurationData sólo con las keys solicitadas originalmente
                const productsConfigurationData: any = {};
                (keys || []).forEach(k => {
                    productsConfigurationData[k] = allData[k];
                });
                const auxlead = allData.leadId ?? '';
                const asesorcodeaux = options.asesorCode || allData.asesorCode || this.utmHandlerService.getUtmParams()['codasesor'] || '';
                const bitacoraIdaux = allData.bitacoraId ?? '';
                const body: any = {
                    SessionId: sessionId,
                    productFamily: 'Arrendamientos',
                    productsConfigurationData,
                    Set_utm_campaign: utmCampaign,
                    Set_utm_content: utmContent,
                    Set_utm_medium: utmMedium,
                    Set_utm_source: utmSource,
                };

                if (screenPercentage){
                    body.screenPercentage = screenPercentage;
                }
                if (auxlead) {
                    body.leadId = auxlead;
                }
                if (getTenantPolicies !== undefined) {
                    body.getTenantPolicies = getTenantPolicies;
                }
                if (leadRequirement !== undefined) {
                    body.leadRequirement = leadRequirement;
                }
                if (leadStatus !== undefined) {
                    body.leadStatus = leadStatus;
                }
                if (getScore !== undefined) {
                    body.getScore = true;
                }
                if (asesorcodeaux) {
                    body.asesorCode = asesorcodeaux;
                }
                if (bitacoraIdaux) {
                    body.bitacoraId = bitacoraIdaux;
                }
                if (getLeadDuplicated !== undefined) {
                    body.getLeadDuplicated = getLeadDuplicated;
                }
                if (gClid) {
                    body.utm_term = gClid;
                }
                
                return body;
            })
        );
    }
}
